export default "/images/logo-dm.svg?1189074922adfa4a0de13cd07223e937";